import "./loader.css";

export default function Loader({ text }) {
  return (
    <div className="mars-loader-wrapper">
      <div className="mars-orbit">
    
<div className="loader-wrapper">
  <span className="loader-letter">M</span>
  <span className="loader-letter">a</span>
  <span className="loader-letter">r</span>
  <span className="loader-letter">s</span>
  <span className="loader-letter">M</span>
  <span className="loader-letter">a</span>
  <span className="loader-letter">t</span>
  <span className="loader-letter">e</span>
  

  <div className="loader"></div>
</div>
</div>

      {text && <p className="mars-loader-text">{text}</p>}
    </div>
  );
}
